import API from "../api/api"; //引入api设置
import {
    seoRender,
    addCDN,
    loadFooter,
    loadGotop,
    loadLoading,
    render
} from '../api/render'; //异步数据渲染方法库
import { rootDir } from '../../config/config';
import imagesLoaded from 'imagesloaded';
import '../utils/tesla';
import '../lib/mCustomScrollbar/jquery.mCustomScrollbar.concat.min'//滚动条依赖

/**
 * 全局对象，这里我设置了api和loading对象，因为每个页面都需要异步请求和loading控制，
 * 如果给window对象扩展别的方法请一定三思，全局变量污染不利于后期维护和功能扩展，尽量不要讲方法挂载在window对象上
 * @type {object} api     初始化api对象，如：api.getRow(id).then(res => (render()))
 * @type {object} loading loading控制loading的隐藏，一般我再加载完banner图后隐藏，也可以在其他合适的时候隐藏
 * @see [注意] 下面用到的{...}花括号可以用来形成一个块级作用域，
 * 避免全局变量污染，这里我用来区分代码功能，让代码更易读，可维护
 */
{
    window.api = new API({
        rootdir: rootDir,
        // fixPath: ['img_url', 'big_img', 'video_src', 'original_path'],
        fixPath: ['img_url', 'big_img', 'original_path'],
    });

    window.loading = {
        show: function () {
            $('body').addClass('bodyso');
        },
        hide: function () {
            // imagesLoaded('#g-content img', function () {
            setTimeout(() => {
                $('#g-loading').fadeOut(500);
                $('body').removeClass('bodyso').css({ 'visibility': 'visible' });
            }, 500);
            // })
        }
    };

    // 微信分享
    window.WeChatShare = {
        Share: function (category_id, img_url, titles, descs) {
            let title = titles,
                desc = descs,
                imgUrl = img_url;
            let url = encodeURIComponent(location.href.split('#')[0]);
            console.log(unescape(url));

            new Promise(resolve => {
                api.getRow({
                    url: unescape(url) + '/tools/yufei.ashx?action=GetWxShareInfo',
                    urls: url,
                    category_id: category_id,
                    img_url: img_url,
                    title: title,
                    desc: desc,
                }).then(res => {
                    if (!res) {
                        return;
                    }
                    let appId = res.appId,//与后端的appid相同
                        noncestr = res.noncestr,
                        timestamp = res.timestamp,
                        urls = res.url,
                        signature = res.signature;
                    title = unescape(res.title);
                    desc = unescape(res.desc);
                    imgUrl = unescape(res.httpurl) + res.img_url;

                    // alert(imgUrl);
                    //alert(appId+" "+noncestr+" "+signature+" "+urls);

                    wx.config({
                        debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: appId, //必填，公众号的唯一标识
                        timestamp: timestamp, // 必填，生成签名的时间戳
                        nonceStr: noncestr, //必填，生成签名的随机串
                        signature: signature,// 必填，签名
                        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ',
                            'onMenuShareWeibo', 'onMenuShareQZone', 'chooseImage',
                            'uploadImage', 'downloadImage', 'startRecord', 'stopRecord',
                            'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice',
                            'translateVoice', 'openLocation', 'getLocation', 'hideOptionMenu',
                            'showOptionMenu', 'closeWindow', 'hideMenuItems', 'showMenuItems',
                            'showAllNonBaseMenuItem', 'hideAllNonBaseMenuItem', 'scanQRCode'] //必填，需要使用的JS接口列表，所有JS接口列表
                    });

                    wx.ready(function () {
                        //朋友圈
                        wx.onMenuShareTimeline({
                            title: title, // 分享标题
                            link: urls,// 分享链接
                            imgUrl: imgUrl, // 分享图标
                            success: function () {
                                // 用户确认分享后执行的回调函数
                                layer.closeAll();
                            },
                            cancel: function () {
                                // 用户取消分享后执行的回调函数
                                layer.closeAll();
                            }
                        });

                        //朋友
                        wx.onMenuShareAppMessage({
                            title: title, // 分享标题
                            desc: desc, // 分享描述
                            link: urls, // 分享链接
                            imgUrl: imgUrl, // 分享图标
                            success: function () {
                                // 用户确认分享后执行的回调函数
                                layer.closeAll();
                            },
                            cancel: function () {
                                // 用户取消分享后执行的回调函数
                                layer.closeAll();
                            }
                        });
                    });
                    resolve();
                });
            });
        }
    }
}

$(function () {
    /**
     * 通用项，每个项目基本都要这三个方法
     * @method seoRender    seo渲染
     * @method addCDN       添加阿里图标cdn到head标签里，项目都用的阿里图标库
     * @method loadLoading  不管哪个页面都想加载loading,然后在必要的时候hide
     * @method loading.show 禁止屏幕滚动 不过可惜只对PC端有效...
     */
    {
        loadLoading("#g-loading", "./default/loading/loading.html");
        loading.show();
        seoRender();
        addCDN();

    }

    /**
     * 尾部加载相关代码
     * @method testEmail   lib库里引入，检测邮箱格式，并发送后台
     * @method updateYear  更新年份
     */
    {
        const updateYear = () => {
            const time = new Date(),
                year = time.getFullYear();
            $(".j-time").html(year);
        };

        // 修复 iOS hover 问题
        document.addEventListener('touchstart', function () { }, false);
        document.addEventListener('touchmove', function () { }, false);

        // 或者使用更具体的修复
        function fixIOSHover() {
            const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if (iOS) {
                document.body.addEventListener('touchstart', function () { });
            }
        }

        /**
         * 将异步渲染代码和回调按顺序结合到一起，顺序很重要！！！先做什么再做什么想清楚！！！
         */
        (async () => {
            let Language = sessionStorage.getItem('Language');
            if (Language == 'CN') {
                await loadFooter("#g-footer", "./default/footer/footer_cn.html")
            } else {
                await loadFooter("#g-footer", "./default/footer/footer.html")
            }
            updateYear();
            scrollScreen();
            mCustomScrollbar();
            fixIOSHover();
        })();
    }

    /**
     *  返回顶部
     */
    {
        (async () => {
            await loadGotop('#g-goTop', './default/gotop/gotop.html');
            toTop();
        })();

        const toTop = () => {
            const toTop = $('#g-goTop');
            let time = null;
            let isTop = null;
            $(window).on('scroll', function () {
                $(document).scrollTop() > 700 ? toTop.fadeIn() : toTop.fadeOut();
            });
            toTop.on('click', function () {
                $("html,body").animate({ scrollTop: 0 }, 500);
            });
        }
    }

    /**
     * 该文件使用的辅助函数，一般我用‘_’开头来区分
     * @method _toggleActive toggleActive
     */
    function _toggleActive(dom) {
        $(dom).toggleClass("active");
    }

    /**
     * 项目展示 通用功能
     * @method   Totop               返回顶部
     * @method   mCustomScrollbar    自定义滚动条
     * @method   scrollScreen        滑动到下一屏
     * */

    /*滑动到下一屏*/
    const scrollScreen = () => {
        $('.nextBtn').on('click', function () {
            $('html,body').stop(true, false).animate({
                scrollTop: $(window).height()
            }, 500);
        })
    }

    /*自定义滚动条*/
    const mCustomScrollbar = () => {
        $('.mCustomScrollbar').mCustomScrollbar({
            autoHideScrollbar: true,
            theme: "dark",
            live: "on"
        });
    }

    //补0
    window.addZero = (num) => {
        if (parseInt(num) < 10) {
            num = '0' + num;
        }
        return num;
    }

    //简体——繁体转换
    window.language = () => {
        function getCookie(cookie_name) {
            var allcookies = document.cookie;
            var cookie_pos = allcookies.indexOf(cookie_name);
            if (cookie_pos != -1) {
                cookie_pos = cookie_pos + cookie_name.length + 1;
                var cookie_end = allcookies.indexOf(';', cookie_pos);

                if (cookie_end == -1) {
                    cookie_end = allcookies.length;
                }

                var value = unescape(allcookies.substring(cookie_pos, cookie_end));
            }

            return value
        }

        // 切换简体
        $('.zh_tran_s').on('click', function () {
            zh_tran('s');
            window.location.reload();
        })
        //切换繁体
        $(".zh_tran_t").on('click', function () {
            zh_tran('t');
            window.location.reload();
        })

        //页面加载完检测是简体还是繁体
        let yuyan = sessionStorage.getItem('Language');
        if (yuyan == 'CN') {
            if (getCookie('zh_choose') == 't') {
                zh_tran('t');
                $(".zh_tran_t").addClass('active');
            } else {
                zh_tran('s');
                $(".zh_tran_s").addClass('active');
            }
        } else {
            $(".page_en").addClass('active');
        }
    }
});


// WEBPACK FOOTER //
// ./src/entry/common.js